import { useRouter } from "next/router";
import { Company } from "../../../../users/models/company.model";
import { IconBuilding, IconMapMarker } from "../../Icons";

interface ValueTemplateProps {
    companies: Company[];
}

const ValueTemplate = (props: ValueTemplateProps) => {
    const { companies } = props;

    const router = useRouter();
    const { companyId, locationId } = router.query as {
        companyId?: string;
        locationId?: string;
    };

    const company = companies.find((company) => company.id === companyId);
    const location = company?.locations?.find(
        (location) => location.id === locationId
    );

    const isLocationSelected = !!locationId;
    const displayName =
        (isLocationSelected ? location?.name : company?.name) || "-";
    const Icon = isLocationSelected ? IconMapMarker : IconBuilding;

    return (
        <div className="flex min-w-0 items-center gap-1.5 text-primary-text">
            <Icon className="size-4.5 shrink-0 md:size-3.5" />
            <span className="min-w-0 truncate">{displayName}</span>
        </div>
    );
};

export default ValueTemplate;
